import _ from 'lodash';
import {calculateChildrenTotalByMode} from 'common/requestDetails/utils';
import {compileContent} from 'common/utils';
import REST from 'go/requests/rest';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const fsTotalLessthanOrEqualValue = (state, props) => {
  const data = _.get(state, props.dataPath, []);
  let totalCost = 0;
  _.forEach(data, (child) => {
    const children = _.get(child, 'children', {});
    _.filter(children, (item) => {
      if (item.itemCode === props.itemCode) {
        totalCost = calculateChildrenTotalByMode(item.children, props.mode);
      }
    });
  });
  return totalCost <= props.value;
};

const unSetPhasedProject = (state, props) => {
  const inputData = _.get(state, props.dataPath, []);
  const data = JSON.parse(JSON.stringify(inputData));
  if (data !== undefined) {
    _.forEach(data, (child) => {
      const children = _.get(child, 'children');
      if (children !== undefined) {
        const keys = Object.keys(children);
        _.each(keys, (key) => {
          const grandChildren = _.get(children[key], 'children');
          if (grandChildren !== undefined) {
            const costKeys = Object.keys(grandChildren);
            _.each(costKeys, (costKey) => {
              const costs = _.get(grandChildren[costKey], 'cost');
              if (costs !== undefined) {
                _.each(costs, (cost) => {
                  if (_.get(cost, '0') !== undefined) {
                    _.unset(cost[0], 'phasedProject');
                  }
                });
              }
            });
          }
        });
      }
    });
  }
  return data;
};

const isEqual = (state, props) => {
  const data = _.get(state, props.dataPath, []);
  const value = _.get(props, 'value');
  return _.isEqual(data, value);
};

const equalsAnyValue = (state, props) => {
  const data = _.get(state, props.dataPath, []);
  const value = _.get(props, 'value');
  return _.includes(value, data);
};

const doesNotContainValue = (state, props) => {
  const data = _.get(state, props.dataPath, []);
  const value = _.get(props, 'value');
  return !_.includes(data, value);
};

const containsValue = (state, props) => {
  const data = _.get(state, props.dataPath, []);
  const value = _.get(props, 'value');
  return _.includes(data, value);
};

const isEmpty = (state, props) => {
  const data = _.get(state, props.dataPath);
  return _.isNil(data);
};

const isNotEmpty = (state, props) => {
  const data = _.get(state, props.dataPath);
  return !_.isNil(data);
};

const buildActivityOptions = (state, props) => {
  const applicationTypeActivities = _.get(
    state,
    'context.programCategoryConfig.applicationTypeActivities'
  );
  const loadItemCodes = _.get(state, 'context.loadItemCodes');
  const applicationType = _.get(state, props.applicationType);
  const refValue = _.get(state, props.path);
  const isSelfSubApplication = _.isEqual(
    _.get(state, 'data.organizationId'),
    _.get(state, 'data.subOrgId')
  );
  const excludePlanOptions = [338, 344];
  const getName = (id) => {
    let itemCodes = loadItemCodes;
    return _.filter(itemCodes, (item) => {
      return Number(item.itemCode) === Number(id);
    });
  };

  const getChildItems = (item) =>
    _.flatMap(item.children, (child) => {
      return getName(child);
    });

  const mergeItems = (item) => {
    const itemObj = _.get(getName(item.itemCode), 0);
    return {
      ...itemObj,
      subActivityList: getChildItems(item),
    };
  };
  let activity = _.chain(applicationTypeActivities)
    .filter((obj) => Number(obj.applicationTypeId) === Number(applicationType))
    .head()
    .value();

  const getSubActivityList = (activities, name) => {
    return _.result(
      _.find(activities, function (obj) {
        return obj.name === name;
      }),
      'subActivityList'
    );
  };

  const filterOptions = (options) => {
    if (!_.isEmpty(options)) {
      const filteredOptions = _.remove(JSON.parse(JSON.stringify(options)), (option) => {
        return !_.includes(excludePlanOptions, option.itemCode);
      });
      return filteredOptions;
    }
    return [];
  };
  let mainActivities = _.chain(activity.items)
    .map((item) => {
      return mergeItems(item);
    })
    .value();
  let options = getSubActivityList(mainActivities, refValue);
  if (Number(applicationType) === 231 && !isSelfSubApplication) {
    options = filterOptions(options);
  }
  return options;
};

const buildChildSelectOptions = (state, props) => {
  const selectedValue = _.get(state, props.path);
  const refData = _.get(state, props.refDataPath);
  const lookupData = _.get(state, props.lookupDataPath);
  const parentOptions = _.get(state, props.parentOptions);

  // Convert options into Map for easy lookup by child key
  const lookupDataByChildKey = new Map();
  _.each(lookupData, (obj) => {
    lookupDataByChildKey.set(obj[props.childKey], obj);
  });

  // Get Parent object by looking at dropdown options of parent select box
  const selectedKey = _.chain(parentOptions)
    .filter((obj) => obj[props.lookupKey] === selectedValue)
    .map((obj) => obj[props.parentKey])
    .head()
    .value();

  // Get child ids from Parent - Child mapping data structure
  const keys = _.chain(refData)
    .filter((obj) => obj[props.parentKey] === selectedKey)
    .map((obj) => obj.children)
    .head()
    .value();

  const objects = _.chain(keys)
    .map((key) => {
      return lookupDataByChildKey.get(key);
    })
    .map((obj) => JSON.parse(JSON.stringify(obj)))
    .value();

  return objects;
};

const delAttachments = (originalState, dataPath) => {
  const newState = JSON.parse(JSON.stringify(originalState));
  const attachmentList = _.get(newState, dataPath);
  const token = cookies.get('token');
  _.map(attachmentList, (att) => {
    REST.attachment
      .deleteAttachment(token, att.resourceId)
      .then(REST.handler.handleResponse)
      .catch((error) => {
        console.error('error');
      });
  });
};

const delAttachmentsAndUnset = (originalState, dataPath) => {
  const newState = JSON.parse(JSON.stringify(originalState));
  const attachmentList = _.get(newState, dataPath);
  const token = cookies.get('token');
  _.map(attachmentList, (att) => {
    REST.attachment
      .deleteAttachment(token, att.resourceId)
      .then(REST.handler.handleResponse);
  });
  _.unset(originalState, dataPath);
};

const calculateCostRatio = (state, props) => {
  const totalProjectBenefitAmount = _.get(state, props.totalProjectBenefitAmount);
  const totalProjectCostAmount = _.get(state, props.totalProjectCostAmount);
  let costRatio = null;
  if (
    totalProjectBenefitAmount &&
    totalProjectCostAmount &&
    _.isFinite(parseFloat(totalProjectBenefitAmount)) &&
    _.isFinite(parseFloat(totalProjectCostAmount))
  ) {
    costRatio = _.floor(
      _.divide(parseFloat(totalProjectBenefitAmount), parseFloat(totalProjectCostAmount)),
      2
    ).toFixed(2);
  }
  return costRatio;
};

function deleteKeyFromJson(json, key) {
  // Check if the json object is an object or array
  if (typeof json === 'object' && json !== null) {
    // If the json object is an array, loop through each element and call the function recursively
    if (Array.isArray(json)) {
      json.forEach((element, index) => {
        json[index] = deleteKeyFromJson(element, key);
      });
    } else {
      // If the json object is an object, loop through each property and call the function recursively
      Object.keys(json).forEach((prop) => {
        if (prop === key) {
          // If the property is the key we want to delete, delete it from the json object
          _.unset(json, `${key}.changes`);
          _.unset(json, `${key}.justification`);
        } else {
          // Otherwise, continue recursively traversing the tree
          json[prop] = deleteKeyFromJson(json[prop], key);
        }
      });
    }
  }
  return json;
}

const unSetAdditionalInfo = (state, props) => {
  const newState = JSON.parse(JSON.stringify(state));
  const fs = _.get(newState, props.setToPath);
  let fsCopy = JSON.parse(JSON.stringify(fs));
  let updatedFs = deleteKeyFromJson(fsCopy, 'additionalInformation');
  return updatedFs;
};

const calculateCostShare = (state, props) => {
  const newState = JSON.parse(JSON.stringify(state));
  const totalAmount = _.get(newState, props.totalAmount);
  const index = props.extraProps.index;
  const share = _.get(newState, compileContent(props.share, index));
  const appRate = _.get(share, 'appRate.0');
  const fedRate = _.get(share, 'fedRate.0');

  if (
    totalAmount &&
    fedRate &&
    _.isFinite(parseFloat(totalAmount)) &&
    _.isFinite(parseFloat(fedRate))
  ) {
    share.fedShare[0] = _.floor(_.multiply(totalAmount, fedRate), 2).toFixed(2);
  }
  if (
    totalAmount &&
    appRate &&
    _.isFinite(parseFloat(totalAmount)) &&
    _.isFinite(parseFloat(appRate))
  ) {
    share.appShare[0] = _.ceil(_.multiply(totalAmount, appRate), 2).toFixed(2);
  }
  return share;
};

const unSelectOtherStateCommunities = (state, props) => {
  const physicalAddressState = _.get(state, props.state);
  const isIndianTribalGovernment = _.isEqual(
    _.get(state, props.subapplicantType),
    'Indian Tribal Government'
  );
  const communities = _.get(state, props.communities);
  const filteredCommunities = _.filter(
    communities,
    (community) => isIndianTribalGovernment || community.state === physicalAddressState
  );
  return filteredCommunities;
};

const checkIfStatutoryStillViolated = (state, props, ruleId, waivedStatutoryPath) => {
  const statutory = _.get(state, props.statutory, []);
  const filteredStatutory = _.filter(statutory, (item) => item.ruleId === ruleId);
  const statutoryStillViolated = _.size(filteredStatutory) > 0;
  if (!statutoryStillViolated) {
    _.unset(state, `${waivedStatutoryPath}.waiverRequested`);
  }
  return statutoryStillViolated;
};

const clearStatutoryWaiverData = (state, props, dataPath) => {
  const stateCopy = JSON.parse(JSON.stringify(state));
  const StatutoryWaiverData = _.get(stateCopy, dataPath);
  _.forEach(StatutoryWaiverData, (item, ruleId) => {
    const waivedStatutoryPath = `${dataPath}.${ruleId}`;
    if (
      item.waiverRequested === false ||
      !checkIfStatutoryStillViolated(stateCopy, props, ruleId, waivedStatutoryPath)
    ) {
      delAttachments(state, `${waivedStatutoryPath}.waiverRequestAttachment`);
      delAttachments(state, `${waivedStatutoryPath}.waiverDeterminationAttachment`);
      _.unset(stateCopy, `${waivedStatutoryPath}.waiverRequestComment`);
      _.unset(stateCopy, `${waivedStatutoryPath}.waiverRequestAttachment`);
      _.unset(stateCopy, `${waivedStatutoryPath}.waiverDeterminationAttachment`);
    }
  });
  return _.get(stateCopy, dataPath);
};

const setBudgetClass = (state, props, dataPath) => {
  return _.get(state, _.get(props, props.props.rootPath) + '.' + props.props.dataPath);
};

const checkIfProjectDeadlineOnlyChange = (state, props, dataPath) => {
  // compares grandAmendment against grantData, returns values that changed or added into grantAmendment.
  const findDiffPaths = (grantData, grantAmendment, diffs) => {
    if (typeof grantAmendment === 'object') {
      const topLevelKeys = Object.keys(grantAmendment);
      topLevelKeys.forEach(e => {
        let propChanged = "";
        if (typeof grantData[e] === 'object' && !!grantData[e] && typeof grantAmendment[e] === 'object' && !!grantAmendment[e]) {
          let subDiffs = [];
          subDiffs = findDiffPaths(grantAmendment[e], grantData[e], subDiffs);
          subDiffs.forEach(d => diffs.push(`${e}.${d}`))
        } else if (grantData[e] !== grantAmendment[e]) {
          
          propChanged = e;
        } else {
          return
        }
        if (propChanged) diffs.push(propChanged)
      })
    }
    return diffs;
  }

  //deep clone
  const grantData = JSON.parse(JSON.stringify(_.get(state, props.grantData, {})));
  const grantAmendment = JSON.parse(JSON.stringify(_.get(state, props.grantAmendment, {})));

  const diffs = [];
  findDiffPaths(grantData, grantAmendment, diffs)
  
  return diffs.length === 1 && _.includes(diffs[0], 'projectCompletion')

}

const evalRuleSet = {
  fsTotalLessthanOrEqualValue,
  isEqual,
  isEmpty,
  isNotEmpty,
  buildActivityOptions,
  buildChildSelectOptions,
  calculateCostRatio,
  delAttachments,
  delAttachmentsAndUnset,
  equalsAnyValue,
  doesNotContainValue,
  containsValue,
  unSelectOtherStateCommunities,
  clearStatutoryWaiverData,
  unSetPhasedProject,
  calculateCostShare,
  unSetAdditionalInfo,
  setBudgetClass,
  checkIfProjectDeadlineOnlyChange,
};

export default {
  evalRuleSet,
};
